import { Routes } from '@angular/router';

export const ROUTE_LOTTERY_TORITO = 'loteria-torito';
export const ROUTE_LOTTERY_TORITO_EN = 'en/lottery-torito';
export const ROUTE_LOTTERY_TORITO_DATE = 'loteria-torito/:date';
export const ROUTE_LOTTERY_TORITO_DATE_EN = 'en/lottery-torito/:date';

export const lotteryRoutes: Routes = [
  {
    path: ROUTE_LOTTERY_TORITO,
    loadComponent: () =>
      import('../pages/lottery-torrito/lottery-torrito.component'),
  },
  {
    path: ROUTE_LOTTERY_TORITO_EN,
    loadComponent: () =>
      import('../pages/lottery-torrito/lottery-torrito.component'),
  },
  {
    path: ROUTE_LOTTERY_TORITO_DATE,
    loadComponent: () =>
      import('../pages/lottery-torrito/lottery-torrito.component'),
  },
  {
    path: ROUTE_LOTTERY_TORITO_DATE_EN,
    loadComponent: () =>
      import('../pages/lottery-torrito/lottery-torrito.component'),
  },
];
